import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import {
  subscriptionPageRequest,
  startProTrial,
  subscribeBasic,
  subscribePro,
  hidePaymentGatewayErrorModal,
} from 'actions/customers/loyalty/loyaltySubscription';
import PaymentGatewayErrorModal from 'components/PaymentGatewayErrorModal';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { formatDecimal } from 'utils/formatter';
import * as clevertapCustomersLoyalty from 'clevertap/customers/loyalty';
import MenuTitleLoyalty from '../Components/MenuTitleLoyalty';
import styles from './Subscribe.css';

class Subscribe extends Component {
  componentWillMount() {
    const { trialEndAt, outletSlot, alreadySubscribed } = this.props;
    const {
      featurePrice,
      featurePricePerMonths,
    } = this.props.loyaltySubscription;

    if (_.isEmpty(featurePrice) || _.isEmpty(featurePricePerMonths)) {
      this.props.subscriptionPageRequest(
        trialEndAt,
        outletSlot,
        alreadySubscribed
      );
    }
  }

  render() {
    const {
      loyaltySubscription: {
        featurePrice,
        featurePricePerMonths,
        subscriptionDetail,
        pageOnLoading,
        isSubscribeBasicButtonEnabled,
        isSubscribeProButtonEnabled,
        pendingPaymentMessage,
        pendingOutletMessage,
        showPaymentGatewayErrorModal,
      },
      alreadySubscribed,
      trialEndAt,
      isOwner,
    } = this.props;

    if (
      pageOnLoading ||
      _.isEmpty(featurePrice) ||
      _.isEmpty(featurePricePerMonths)
    ) {
      return null;
    }

    const detailBasic = subscriptionDetail.Loyalty;
    const detailPro = subscriptionDetail['Loyalty Pro'];

    const trialDurationDaysPro = detailPro.trial_duration_days;
    const featureTrialPro = trialDurationDaysPro > 0;
    const featurePricePerMonthsPro = featurePricePerMonths['Loyalty Pro'];
    const trialEndAtPro = alreadySubscribed
      ? moment().add(trialDurationDaysPro, 'days')
      : moment
          .min([moment().add(trialDurationDaysPro, 'days'), moment(trialEndAt)])
          .toString();
    const messages =
      pendingPaymentMessage !== null
        ? pendingPaymentMessage
        : pendingOutletMessage !== null
        ? pendingOutletMessage
        : null;

    return (
      <div>
        <div className={`row ${styles['menu-title-loyalty-row']}`}>
          <MenuTitleLoyalty
            menuTitle="Loyalty Program"
            loyaltySubscription={this.props.loyaltySubscription}
            goToSubscribeView={this.props.goToSubscribeView}
            showUpgradeToProButton={false}
          />
          <div className={`col-md-4`}>
            <div className="pull-right">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.props.onClickCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>

        <div className={`row ${styles['mar-top-50px']}`}>
          {/* Empty Div for space */}
          <div className={`col-sm-1 col-md-1 col-lg-2`} />

          {/* CRM BASIC Division */}
          <div
            className={`col-sm-4 col-md-4 col-lg-4 ${styles['crm-basic-box']}`}
          >
            {/* Box Title */}
            <div
              className={`${styles['header-cell']} ${styles['title-basic']}`}
            >
              <b>CRM Basic</b>
            </div>
            <hr />
            <div className={`${styles['price-cell']}`}>
              <div>
                <span className={styles['price-basic-text']}>
                  <b>FREE</b>
                </span>
              </div>
              <div>
                <span className={styles['price-basic-sub-text']}>
                  {' '}
                  Forever{' '}
                </span>
              </div>
            </div>
            <hr />
            <div className={styles['box-cell']}>
              <div className={styles['box-cell-wraper']}>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
                <spam className={styles['mar-left-10px']}>
                  Maximum 100 members
                </spam>
              </div>
            </div>
            <div className={styles['box-cell']}>
              <div className={styles['box-cell-wraper']}>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
                <spam className={styles['mar-left-10px']}>
                  Earn points by amount spent
                </spam>
              </div>
            </div>

            <div className={styles['box-cell']}>
              <div className={styles['box-cell-wraper']}>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
                <spam className={styles['mar-left-10px']}>
                  Redeem discount on total sale
                </spam>
              </div>
            </div>

            <div className={styles['box-cell']}>
              <div className={styles['box-cell-wraper']}>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
                <spam className={styles['mar-left-10px']}>
                  Get customer feedback
                </spam>
              </div>
            </div>

            {/* Section link for comparing plans */}
            <div className={styles['box-cell']}>
              <div className={styles['compare-plan-box']}>
                <a href="#comparisonDiv">
                  <span className="glyphicon glyphicon-chevron-right" />
                  <spam className={styles['mar-left-10px']}>Compare plans</spam>
                </a>
              </div>
            </div>
            <div className={styles['box-cell']}>
              {!detailBasic.is_active && (
                <div className={styles['button-box']}>
                  <button
                    className={`${styles['button-basic']}`}
                    disabled={!isSubscribeBasicButtonEnabled}
                    onClick={this._onClickStartBasic}
                  >
                    GET STARTED
                  </button>
                </div>
              )}
              {detailBasic.is_active && (
                <div className={styles['button-box']}>
                  <button
                    className={`${styles['button-basic-subscribed']}`}
                    disabled
                  >
                    YOUR CURRENT PLAN
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className={`col-sm-1 col-md-1 col-lg-1`} />

          {/* CRM Pro Division */}
          <div
            className={`col-sm-4 col-md-4 col-lg-4 ${styles['crm-pro-box']}`}
          >
            {/* Box Title */}
            <div className={`${styles['header-cell']} ${styles['title-pro']}`}>
              <b>
                <span>CRM</span>
              </b>{' '}
              <span className={styles['title-text-pro']}>&nbsp;Pro&nbsp;</span>
            </div>
            <hr />
            <div className={styles['price-cell']}>
              <div className={styles['price-pro']}>
                <b>
                  <span className={styles['price-pro-text']}>IDR &nbsp;</span>
                  <span>207.</span>
                  <span className={styles['price-pro-post-text']}>500</span>
                </b>
              </div>
              <div className={styles['price-pro-sub']}>
                <span>per month/outlet, Billed Annually</span>
                <br />
                <span>IDR 249.000, Billed Monthly</span>
              </div>
            </div>
            <hr />
            <div className={styles['box-cell']}>
              <div className={styles['box-cell-wraper']}>
                <spam style={{ marginLeft: '25px' }}>
                  <b>Everything on Basic, plus</b>
                </spam>
              </div>
            </div>
            <div className={styles['box-cell']}>
              <div className={styles['box-cell-wraper']}>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
                <spam className={styles['mar-left-10px']}>
                  Unlimited members
                </spam>
              </div>
            </div>
            <div className={styles['box-cell']}>
              <div className={styles['box-cell-wraper']}>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
                <spam className={styles['mar-left-10px']}>
                  Earn points by item or category
                </spam>
              </div>
            </div>
            <div className={styles['box-cell']}>
              <div className={styles['box-cell-wraper']}>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
                <spam className={styles['mar-left-10px']}>Redeem items</spam>
              </div>
            </div>

            {/* Section link for comparing plans */}
            <div className={styles['box-cell']}>
              <div className={styles['compare-plan-box']}>
                <a href="#comparisonDiv">
                  <span className="glyphicon glyphicon-chevron-right" />
                  <spam className={styles['mar-left-10px']}>Compare plans</spam>
                </a>
              </div>
            </div>
            <div className={styles['box-cell']}>
              {!detailPro.is_active && featureTrialPro && isOwner && (
                <div className={styles['button-box']}>
                  <button
                    className={styles['button-pro']}
                    onClick={this._onClickStartProTrial}
                  >
                    START 14-DAY TRIAL
                  </button>
                </div>
              )}
              {!detailPro.is_active && featureTrialPro && isOwner && (
                <div className={styles['feature-due-date']}>
                  Your free trial will expire on{' '}
                  {moment(trialEndAtPro).format('DD MMM YYYY')}
                </div>
              )}
              {!detailPro.is_active && featureTrialPro && !isOwner && (
                <div className={styles['button-box']}>
                  <button
                    className={styles['button-basic-subscribed']}
                    disabled
                  >
                    START 14-DAY TRIAL
                  </button>
                </div>
              )}
              {!detailPro.is_active && featureTrialPro && !isOwner && (
                <div className={styles['feature-due-date']}>
                  Please contact the business owner to activate this feature
                </div>
              )}
              {!detailPro.is_active && !featureTrialPro && isOwner && (
                <div className={styles['button-box']}>
                  <button
                    className={styles['button-pro']}
                    disabled={!isSubscribeProButtonEnabled}
                    onClick={this._onClickStartPro}
                  >
                    BUY NOW
                  </button>
                </div>
              )}
              {!detailPro.is_active && !featureTrialPro && isOwner && (
                <div className={styles['feature-due-date']}>
                  Your free trial has expired
                </div>
              )}
              {!detailPro.is_active && !featureTrialPro && !isOwner && (
                <div className={styles['button-box']}>
                  <button
                    className={styles['button-basic-subscribed']}
                    disabled
                  >
                    BUY NOW
                  </button>
                </div>
              )}
              {!detailPro.is_active && !featureTrialPro && !isOwner && (
                <div className={styles['feature-due-date']}>
                  Please contact the business owner to activate this feature
                </div>
              )}
              {!detailPro.is_active && !featureTrialPro && messages && (
                <div className={styles['feature-messages']}>{messages}</div>
              )}
              {detailPro.is_active && (
                <div className={styles['button-box']}>
                  <button className={styles['button-pro']} disabled>
                    YOUR CURRENT PLAN
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className={`col-sm-1 col-md-1 col-lg-1`} />
        </div>

        {/* Division for Detailed Plan Comparison */}
        <div className={styles['comparison-box']} id="comparisonDiv">
          <div className={styles['comparison-box-title']}>
            <span>
              {' '}
              <b>Detailed Plan Comparison</b>
            </span>
          </div>
          <hr className={styles['comparison-box-line']} />
          <table className={styles['comparison-table']}>
            <tr>
              <th style={{ width: '40%' }} />
              <th>
                <b>CRM Basic</b>
              </th>
              <th>
                <b>
                  <span style={{ color: '#345CBA' }}>CRM</span>
                </b>{' '}
                <span className={styles['title-text-pro']}>
                  &nbsp;Pro&nbsp;
                </span>
              </th>
            </tr>
            <tr>
              <td>
                <spam className="pull-left">Members</spam>
                <RenderTooltip
                  id="1"
                  info="The number of members you can sign up for your loyalty program"
                />
              </td>
              <td>
                <span>100</span>
              </td>
              <td>
                <span>Unlimited</span>
              </td>
            </tr>
            <tr>
              <td colSpan="3" className={`${styles['highlight-row']}`}>
                <b>Earning Points</b>
              </td>
            </tr>

            <tr>
              <td>
                <spam className="pull-left">By amount spent</spam>
                <RenderTooltip info="Members earn points based on the total amount spent in every sale" />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
            </tr>

            <tr>
              <td>
                <spam className="pull-left">By item or category</spam>
                <RenderTooltip info="Members earn points by purchasing items or items in a category" />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-remove ${
                    styles['red-color']
                  }`}
                />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
            </tr>

            <tr>
              <td colSpan="3" className={`${styles['highlight-row']}`}>
                <b>Redeeming Rewards</b>
              </td>
            </tr>
            <tr>
              <td>
                <spam className="pull-left">Discount the entire sale</spam>
                <RenderTooltip info="Members redeem points to get a discount on the entire sale" />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
            </tr>

            <tr>
              <td>
                <spam className="pull-left">Discount an item or category</spam>
                <RenderTooltip info="Members redeem points to get discounts on certain items or items in a category" />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-remove ${
                    styles['red-color']
                  }`}
                />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
            </tr>

            <tr>
              <td>
                <spam className="pull-left">Redeem a free item</spam>
                <RenderTooltip info="Members redeem points to get free items" />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-remove ${
                    styles['red-color']
                  }`}
                />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
            </tr>

            <tr>
              <td colSpan="3" className={`${styles['highlight-row']}`}>
                <b>Manage Loyalty Program</b>
              </td>
            </tr>
            <tr>
              <td>
                <spam className="pull-left">Edit program</spam>
                <RenderTooltip info="Change how members can earn points and redeem rewards" />
              </td>
              <td className={styles['compare-table-cell']}>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
              <td className={styles['compare-table-cell']}>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
            </tr>

            <tr>
              <td>
                <spam
                  className="pull-left"
                  style={{ width: '90%', 'white-space': 'normal' }}
                >
                  Reset program (incl. Members &amp; Points)
                </spam>
                <RenderTooltip info="Erase your entire loyalty program, member data, and member points to start a new loyalty program" />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-remove ${
                    styles['red-color']
                  }`}
                />
              </td>
              <td>
                <span
                  className={`glyphicon glyphicon-ok ${styles['green-color']}`}
                />
              </td>
            </tr>

            <tr style={{ height: '162px' }}>
              <td style={{ border: '0px' }} />
              <td>
                <div className={`${styles['price-cell']}`}>
                  <div>
                    <span className={styles['price-basic-text']}>
                      <b>FREE</b>
                    </span>
                  </div>
                  <div>
                    <span className={styles['price-basic-sub-text']}>
                      {' '}
                      Forever{' '}
                    </span>
                  </div>
                </div>
                <div
                  className={styles['box-cell']}
                  style={{ marginTop: '7px' }}
                >
                  {!detailBasic.is_active && (
                    <div>
                      <button
                        className={`${styles['button-basic']}`}
                        disabled={!isSubscribeBasicButtonEnabled}
                        onClick={this._onClickStartBasic}
                      >
                        GET STARTED
                      </button>
                    </div>
                  )}
                  {detailBasic.is_active && (
                    <div>
                      <button
                        className={`${styles['button-basic-subscribed']}`}
                        disabled
                      >
                        CURRENT PLAN
                      </button>
                    </div>
                  )}
                </div>
              </td>

              <td>
                <div className={styles['price-pro']}>
                  <b>
                    <span className={styles['price-pro-text']}>IDR &nbsp;</span>
                    <span>207.</span>
                    <span className={styles['price-pro-post-text']}>500</span>
                  </b>
                </div>
                <div className={styles['price-pro-sub']}>
                  <span>per month/outlet, Billed Annually</span>
                  <br />
                  <span>
                    IDR {formatDecimal(featurePricePerMonthsPro)} Billed Monthly
                  </span>
                </div>
                <div
                  className={styles['box-cell']}
                  style={{ marginTop: '5px' }}
                >
                  {!detailPro.is_active && featureTrialPro && isOwner && (
                    <div>
                      <button
                        className={styles['button-pro']}
                        onClick={this._onClickStartProTrial}
                      >
                        START 14-DAY TRIAL
                      </button>
                    </div>
                  )}
                  {!detailPro.is_active && featureTrialPro && isOwner && (
                    <div className={styles['feature-due-date']}>
                      Your free trial will expire on{' '}
                      {moment(trialEndAtPro).format('DD MMM YYYY')}
                    </div>
                  )}
                  {!detailPro.is_active && featureTrialPro && !isOwner && (
                    <div>
                      <button
                        className={styles['button-basic-subscribed']}
                        disabled
                      >
                        START 14-DAY TRIAL
                      </button>
                    </div>
                  )}
                  {!detailPro.is_active && featureTrialPro && !isOwner && (
                    <div className={styles['feature-due-date']}>
                      Please contact the business owner to activate this feature
                    </div>
                  )}
                  {!detailPro.is_active && !featureTrialPro && isOwner && (
                    <div>
                      <button
                        className={styles['button-pro']}
                        disabled={!isSubscribeProButtonEnabled}
                        onClick={this._onClickStartPro}
                      >
                        BUY NOW{' '}
                      </button>
                    </div>
                  )}
                  {!detailPro.is_active && !featureTrialPro && isOwner && (
                    <div className={styles['feature-due-date']}>
                      Your free trial has expired
                    </div>
                  )}
                  {!detailPro.is_active && !featureTrialPro && !isOwner && (
                    <div>
                      <button
                        className={styles['button-basic-subscribed']}
                        disabled
                      >
                        BUY NOW
                      </button>
                    </div>
                  )}
                  {!detailPro.is_active && !featureTrialPro && !isOwner && (
                    <div className={styles['feature-due-date']}>
                      Please contact the business owner to activate this feature
                    </div>
                  )}
                  {!detailPro.is_active && !featureTrialPro && messages && (
                    <div className={styles['feature-messages']}>{messages}</div>
                  )}
                  {detailPro.is_active && (
                    <div>
                      <button className={styles['button-pro']} disabled>
                        {' '}
                        CURRENT PLAN
                      </button>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          </table>
          <PaymentGatewayErrorModal
            showModal={showPaymentGatewayErrorModal}
            onHide={this._hidePaymentGatewayErrorModal}
            totalPrice={featurePrice['Loyalty Pro'].final_price}
          />
        </div>
      </div>
    );
  }

  _onClickStartBasic = e => {
    e.stopPropagation();
    const { isOwner } = this.props;
    if (isOwner) {
      this.props.subscribeBasic();
      clevertapCustomersLoyalty.loyaltyStartBasic();
      this.props.afterSubscribe();
    }
  };

  _onClickStartPro = e => {
    e.stopPropagation();
    const {
      loyaltySubscription: { featurePrice },
      isOwner,
    } = this.props;
    if (isOwner) {
      const featureData = {
        type: 'FeatureBilling',
        feature_name: 'Loyalty Pro',
        total_amount: featurePrice['Loyalty Pro'].final_price,
      };
      this.props.subscribePro(featureData);
      clevertapCustomersLoyalty.loyaltyStartProUpgrade();
      this.props.afterSubscribe();
    }
  };

  _onClickStartProTrial = e => {
    e.stopPropagation();
    const { isOwner } = this.props;
    if (isOwner) {
      this.props.startProTrial();
      clevertapCustomersLoyalty.loyaltyStartProTrial();
      this.props.afterSubscribe();
    }
  };

  _hidePaymentGatewayErrorModal = () => {
    const { isOwner } = this.props;
    if (isOwner) {
      this.props.hidePaymentGatewayErrorModal();
    }
  };
}

function RenderTooltip({ info }) {
  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{info}</Tooltip>}>
      <span
        className="glyphicon glyphicon-info-sign pull-right"
        style={{
          'pointer-events': 'auto',
          cursor: 'pointer',
          marginRight: '5px',
        }}
      />
    </OverlayTrigger>
  );
}

export default connect(
  null,
  {
    subscriptionPageRequest,
    subscribeBasic,
    subscribePro,
    startProTrial,
    hidePaymentGatewayErrorModal,
  }
)(Subscribe);
